module.exports = __webpack_public_path__ + "static/img/d_file.77aa266a.png";